module.exports = __webpack_public_path__ + "media/images/amenities_icons/shuffle_board-173973dec11290261f46105867ad1aa9.svg";